angular.module('impactx.smartform').directive('ixSmartFormViewer', function (SmartFormTemplateCache, SmartFormService, $timeout) {
    return {
        restrict: 'E',
        scope: {
            config: "=",
            nameEditable: "=",
            smartFormTitle: "=",
            hideTitle: "="
        },
        templateUrl: 'shared/smartform/templates/smart-form-viewer.tmpl.html',
        link: function (scope) {
            scope.$watch('config', function (config) {
                if (config) {
                    scope.identifier = impactX.isDefined(scope, 'config.identifier');
                    scope.title = impactX.isDefined(scope, "config.title");

                    if (impactX.isDefined(scope, 'config.entries')) {
                        addSmartFormToCache(scope.identifier, scope.config.entries);
                    }

                    function addSmartFormToCache(smartFormIdentifier, entries) {
                        angular.forEach(entries, function (entry) {
                            entry.layout.readOnly = false;
                            entry.layout.editable = false;
                            SmartFormTemplateCache.insertComponent(smartFormIdentifier, entry);
                        });
                    }

                    scope.smartFormGridsterOptions = SmartFormTemplateCache.createSmartFormGridsterConfig(scope.config.layout);
                    scope.smartFormGridsterOptions.draggable.enabled = false;
                    scope.smartFormGridsterOptions.resizable.enabled = false;

                    // we need this timeout for gridster to reset the columns BEFORE the entries are added.
                    // if we do not use a timeout here, for some reason, gridster adds the entries as if there was the old amount of columns.
                    $timeout(function () {
                        var cachedForm = SmartFormTemplateCache.getForm(scope.identifier);
                        scope.config.entries = SmartFormService.convertObjectToArray(cachedForm);
                    }, 0);
                }
            });
        }
    }
});